import React, { useEffect, useState } from 'react';
import { Button, Form } from 'antd';
import { Grid } from '@mui/material';
import CustomAccordion from '../CustomAccordion';
import GrossRentHistory from './GrossRentHistory';
// import AdvanceAmountHistory from './AdvanceAmountHistory';
import pdfIcon from 'assets/images/icons/pdf_red.svg';
import pdfIconDisable from 'assets/images/icons/pdf_white.svg';
import CardAccordion from '../../CardAccordion';
// import { Box } from '@mui/material';
const LeaseHistory = ({ viewData, selectHistory }) => {
	const form = Form.useFormInstance();
	const [listLength, setListLength] = useState(0);

	const grossRentListSet = form.getFieldValue('grossRentListSet');

	useEffect(() => {
		setListLength(grossRentListSet?.length || 0);
	}, [grossRentListSet]);

	// const advanceAmountListSet = form.getFieldValue('advanceAmountListSet');

	return (
		<>
			<CustomAccordion
				title="Lease Payment Schedule"
				customHeaderSX={{
					backgroundColor: '#e1f0ff !important',
					p: '10px',
				}}
				typographySX={{ fontSize: '16px !important' }}
				darkTitle={true}
				sx={{ mb: 2 }}
			>
				<Grid container spacing={3} sx={{ p: 2 }}>
					{grossRentListSet?.map((item, index) => (
						// 2. Each item is a Grid item. On large screens (lg), they take 6 of 12 columns (i.e., 50% width).
						// On smaller screens, they take 12 of 12 columns (100% width), stacking automatically.
						<Grid
							item
							xs={12}
							lg={
								index === 0 && listLength !== 2
									? 12
									: index === 0 && listLength === 2
										? 6
										: listLength > 2 && listLength % 2 === 0 && index === listLength - 1
											? 12
											: 6
							}
							key={index}
						>
							<GrossRentHistory data={item} index={index} otherChanges={viewData?.data?.changes[index]} />
						</Grid>
					))}
				</Grid>
			</CustomAccordion>
			<CardAccordion
				title="Other Changes History"
				customHeaderSX={{
					backgroundColor: '#e1f0ff !important',
					p: '10px',
				}}
				typographySX={{ fontSize: '16px !important' }}
				darkTitle={true}
				sx={{ mb: 2 }}
			>
				<Button
					type="primary"
					style={{
						fontSize: '13px',
						fontWeight: '500',
						borderRadius: '6px',
						marginRight: '3px',
						display: 'flex',
						alignItems: 'center',
						gap: '6px',
						...(viewData?.history?.length === 0 ? { backgroundColor: '#6c757d' } : {}),
					}}
					onClick={(e) => {
						e.stopPropagation();
						if (selectHistory) {
							selectHistory({ ...viewData, ...viewData?.data, id: viewData?._id });
						} else if (viewData?.selectHistory) {
							viewData.selectHistory({ ...viewData, ...viewData?.data, id: viewData?._id });
						}
					}}
				>
					<img src={viewData?.history?.length > 1 ? pdfIcon : pdfIconDisable} width={16} height={16} alt="view" />
					Log
				</Button>
			</CardAccordion>
		</>
	);
};

export default LeaseHistory;
